import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
// import Customericon from '../../assets/customer-icon.png';
// import Editicon from '../../assets/icons8-edit.png';
// import Deleteicon from '../../assets/icons8-trash-50.png';
import {  get, patch, getFreshToken } from '../../custom_libraries/serverRequests';
import { Switch, Button } from '@mui/material/';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";

class UserPermissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_list: [],
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 15,
            // toggleStates: {}, // Tracks both "Is Admin" and "Is Client" states for each user_id
            userType:'',
            post_user_info:{},
            is_checked:false,
            userId:'',
            error1:false,
            success2:false,
            error2: false

        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.validateSignedIn();
          }, 0);
        this.getUsersList();
    }

    validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);
      
          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
      }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.error1 !== prevState.error1 ||
            this.state.success2 !== prevState.success2 ||
            this.state.error2 !== prevState.error2
        ) {
            if (
                this.state.error1 ||
                this.state.success2 ||
                this.state.error2
            ) {
                setTimeout(() => {
                    this.setState({
                        error1: false,
                        success2: false,
                        // error2:false
                    });
                }, 3000); // 4.5 second

                setTimeout(() => {
                    this.setState({
                        error2:false
                    });
                }, 5500); // 4.5 second
            }
        }
    }

    getUsersList = async () => {
        console.log("Fetching data from:", urls.GET_USERS);
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let dealer_id= localStorage.getItem(globalVariables.USER_ID);
            console.log("--------dealer_id---------", dealer_id);
            console.log("--------auth token---------", access_token);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            }
           let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
           console.log("--------url---------", url);
            const response = await get(urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id), headers); // API call
            console.log("--------response------getUsersList for permission---", response);
            // Validate the response and extract results
            if (!response || !response.data || !Array.isArray(response.data)) {
                console.error("Invalid response or results:", response);
                this.setState({ user_list: [] });
                return;
            }
            this.setState({ user_list: response.data });
            console.log("user_list---------", this.state.user_list);
        } catch (error) {
            console.error("Error in getUsersList:", error);
            this.setState({ user_list: [] });
        }
    };

    handleChangePage = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value });
      };

    handleToggle = (user_id, toggleType, isChecked) => {
        this.setState((prevState) => ({
            user_list: prevState.user_list.map((user) =>
                user.user_id === user_id
                    ? { ...user, user_type: isChecked ? toggleType : "" } // Update user_type based on toggle
                    : user
            ),
            userType: toggleType,
            userId: user_id,
            is_checked : isChecked
        }), () => {
            console.log("Updated user_list:", this.state.user_list);
            console.log ("handleToggle------", user_id, toggleType, isChecked);
        });
    };
    

    handleUpdateUserPermissions = async (userType) => {
        const {userId, is_checked } = this.state;
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            
            console.log("------user_id in update user permission-----", userId, userType);
            const url = urls.USER_DETAILS(userId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL

            // console.log(`API Response for LoadSelectedUserInfo ${userId}:`, response);
            let data = response.data

            if (data && Object.keys(data).length > 0) {
                console.log(`API Response for LoadSelectedUserInfo ${userId}:`, data);
                let post_data = {
                    "user_id": userId,
                    "first_name":data.first_name,
                    "last_name": data.last_name,
                    "phoneno": data.phoneno,
                    "email": data.email,
                    "is_active": data.is_active,
                    "user_type" : userType,
                    }
                    console.log("----post_data----", post_data);

                    post_data = JSON.stringify(post_data)

                    console.log("---is checked----", is_checked);

                if (is_checked){
                    let response = await patch(urls.UPDATE_USER_DEATILS(userId), post_data, headers)
                    console.log("response ==>", response)
                            
                    if (response && response.detail === "User updated successfully.") {
                        // alert("Site updated successfully.");
                        this.setState({ 
                            success2: true 
                        })
                        setTimeout(() => {
                            this.getUsersList();
                        }, 2000);
                    } 
                }else {
                    // alert("Error updating site. Please try again.");
                    this.setState({ 
                        error2: true 
                    })
                }

            } 
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }       
    }
        
    render() {
        const { user_list, currentPage, rowsPerPage, searchInput, error1, success2, error2 } = this.state;

        // Filter user list based on search input
        // const filteredClientList = user_list.filter((user) =>
        //     (user.first_name && user.first_name.toLowerCase().includes(searchInput.toLowerCase())) ||
        //     (user.address && user.address.toLowerCase().includes(searchInput.toLowerCase()))
        // );
        
        // Filter devices based on search input
        const filteredUserList = user_list.filter((user) =>
        user.first_name.toLowerCase().includes(searchInput.toLowerCase())
        );

        // Calculate pagination indices
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredUserList.slice(indexOfFirstRow, indexOfLastRow);

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>

                <div className="home-container" style={{ display: 'flex', flex: '1', overflow: 'hidden', height: '100vh', paddingLeft: '5px' }}>                   
                    <div style={{ flex: '5', marginLeft: '0.5%', padding: '20px', overflowY: 'auto' }}>
                        <div>
                            <div className="search-container">
                            <span>
                            {error1 ? (
                                                <Alert severity="error">Server Error! User permission was not Updated!</Alert>
                                            ) : error2 ? (
                                                <Alert severity="error">You can not disable both permissions! Please set one of the roles.</Alert>
                                            ): success2 ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success"> User permission was updated successfully!</Alert>
                                            ) : null}
                            </span>
                                <input
                                type="text"
                                id="search-input"
                                placeholder="Search by user name"
                                value={searchInput}
                                onChange={this.handleSearchInputChange}
                                />
                            </div>
                            <div>
                            <div>
                                <table id="devices" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom:'15px', textAlign:'center' }}>
                                    <thead>
                                        <tr>
                                        <th> Name</th>
                                        <th> Email </th>
                                        <th>Is Admin?</th>
                                        <th>Is Client?</th>
                                        <th> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRows.map((user) => {
                                            // Split the created_at string to separate date and time 
                                            // Ensure default toggle states exist for the user
                                            // const userToggles = this.state.toggleStates[user.user_id] || { TechnicianUser: false, CustomerUser: false };
                                            // const TechnicianUser = userToggles.TechnicianUser || false;
                                            // const CustomerUser = userToggles.CustomerUser || false;                    
                                            return (
                                            <tr key={user.user_id}>
                                                <td>{user.first_name}</td>
                                                <td>{user.email}</td>
                                                <td> 
                                                <Switch
                                                    checked={user.user_type === "TechnicianUser"}
                                                    onChange={(event) => this.handleToggle(user.user_id, "TechnicianUser", event.target.checked)}
                                                    name={`TechnicianUser_${user.user_id}`}
                                                    color="primary"
                                                    size="small"
                                                    disabled={user.user_type === "CustomerUser"} // Disable "Is Admin" if "Is Client" is enabled
                                                />
                                                </td>
                                                <td>
                                                {/* <Switch
                                                    checked={CustomerUser}
                                                    onChange={(event) => this.handleToggle(user.user_id, "CustomerUser", event.target.checked)}
                                                    name={`CustomerUser_${user.user_id}`}
                                                    color="primary"
                                                    size="small"
                                                    disabled={TechnicianUser} // Disable "Is Client" if "Is Admin" is enabled
                                                /> */}
                                                <Switch
                                                    checked={user.user_type === "CustomerUser"} // Dynamically reflects state
                                                    onChange={(event) => this.handleToggle(user.user_id, "CustomerUser", event.target.checked)}
                                                    name={`CustomerUser_${user.user_id}`}
                                                    color="primary"
                                                    size="small"
                                                    disabled={user.user_type === "TechnicianUser"} // Disable based on another condition
                                                />

                                                </td>
                                                <td><Button className="permissionSave" style={{border:'1px solid #1be95b'}} onClick={()=>this.handleUpdateUserPermissions(this.state.userType)}><b>Save</b>  </Button> </td>
                                            </tr>
                                            );
                                        })}
                                        {currentRows.length === 0 && (
                                        <tr>
                                            <td colSpan="15" style={{ textAlign: "center", padding: "20px", color:'orange' }}>
                                            No user found.
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                                </div>
                            

                            </div>
                            <div style={{ marginTop: '2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                <button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    {"< Prev"}
                                </button>&emsp;
                                <span style={{ fontSize: 'small' }}>
                                    {`Page ${currentPage} / ${Math.ceil(filteredUserList.length / rowsPerPage)}`}
                                </span>&emsp;
                                <button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage + 1)}
                                    disabled={currentPage === Math.ceil(filteredUserList.length / rowsPerPage)}
                                >
                                    {"Next >"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNavigate(UserPermissions);